var _rect, _ellipse, _rect2, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCodeEditor = function SvgCodeEditor(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 71,
    fill: "none"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 35,
    cy: 65.5,
    rx: 26,
    ry: 1.5,
    fill: "url(#paint0_linear_458_48642)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 14.8516,
    width: 52,
    height: 41.4074,
    rx: 5.11552,
    fill: "url(#paint1_linear_458_48642)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 19.7112C9 16.886 11.2903 14.5957 14.1155 14.5957H55.8845C58.7097 14.5957 61 16.886 61 19.7112V23.5834H9V19.7112Z",
    fill: "#BBDEFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4988 44.8975L23.6703 41.0076C23.2234 40.7161 23 40.2097 23 39.4885C23 39.1356 23.0534 38.844 23.1603 38.6138C23.2769 38.3683 23.4469 38.1689 23.6703 38.0154L29.4988 34.1025C29.6639 33.9951 29.8096 33.9721 29.9359 34.0335C30.0719 34.0949 30.1788 34.2099 30.2565 34.3787C30.3342 34.5475 30.3779 34.7393 30.3876 34.9542C30.3973 35.169 30.3682 35.3761 30.3002 35.5756C30.2419 35.7597 30.1302 35.9055 29.9651 36.0129L23.612 40.225V38.798L29.9651 43.0101C30.1302 43.1175 30.2419 43.2709 30.3002 43.4704C30.3682 43.6546 30.3973 43.854 30.3876 44.0689C30.3779 44.2683 30.3342 44.4525 30.2565 44.6213C30.1788 44.7901 30.0719 44.9051 29.9359 44.9665C29.8096 45.0279 29.6639 45.0049 29.4988 44.8975Z",
    fill: "#90CAF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5012 44.8975C40.3361 45.0049 40.1855 45.0279 40.0495 44.9665C39.9232 44.9051 39.8212 44.7901 39.7435 44.6213C39.6658 44.4525 39.6221 44.2683 39.6124 44.0689C39.6027 43.854 39.6318 43.6546 39.6998 43.4704C39.7678 43.2709 39.8795 43.1175 40.0349 43.0101L46.388 38.798V40.225L40.0349 36.0129C39.8795 35.9055 39.7678 35.7597 39.6998 35.5756C39.6318 35.3761 39.6027 35.169 39.6124 34.9542C39.6221 34.7393 39.6658 34.5475 39.7435 34.3787C39.8212 34.2099 39.9232 34.0949 40.0495 34.0335C40.1855 33.9721 40.3361 33.9951 40.5012 34.1025L46.3297 38.0154C46.7766 38.307 47 38.798 47 39.4885C47 39.8414 46.9417 40.1483 46.8251 40.4092C46.7183 40.6547 46.5531 40.8542 46.3297 41.0076L40.5012 44.8975Z",
    fill: "#90CAF9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_458_48642",
    x1: 66.9091,
    y1: 64.2,
    x2: 65.5123,
    y2: 75.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DD3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF8FF",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_458_48642",
    x1: -0.862069,
    y1: 23.436,
    x2: 27.6689,
    y2: 64.5824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4F3FE"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCodeEditor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "code-editor.d3fee824cba9f903212a6e272e8d71f8.svg";